/*
 * Copyright (c) 2015 - 2023 by KAA Soft. All rights reserved.
 */

import { adminConfig } from "../adminConfig";
// import {httpRequest} from "./http-request";

// export async function getBooksByApi(route, params) {
// 	return httpRequest({
// 		url: route ?? adminConfig.routes.apiBookSearch,
// 		data: params
// 	}).then(function (response) {
// 		return {
// 			books: response?.data?.books,
// 			pages: response?.data?.pages
// 		}
// 	});
// }

export var bookCopyBorrowingStatus = 'Borrowed';
export var bookCopyLostStatus = 'Lost';
export function getBookAuthors(authors) {
  var markup = '',
    lastIndex = authors.length - 1;
  for (var i = 0; i < authors.length; i++) {
    if (!!authors[i].firstName) {
      markup += authors[i].firstName + ' ' + authors[i].lastName;
    } else {
      markup += authors[i].lastName;
    }
    if (lastIndex !== i) {
      markup += ", ";
    }
  }
  return markup;
}
export function getBookGenres(genres) {
  var markup = '',
    lastIndex = genres.length - 1;
  for (var i = 0; i < genres.length; i++) {
    markup += genres[i].name;
    if (lastIndex !== i) {
      markup += ", ";
    }
  }
  return markup;
}
export function getMoreBtn() {
  return '<button type="button" class="btn-link more-action" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M4.5 10.5c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5S6 12.825 6 12s-.675-1.5-1.5-1.5zm15 0c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5S21 12.825 21 12s-.675-1.5-1.5-1.5zm-7.5 0c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5 1.5-.675 1.5-1.5-.675-1.5-1.5-1.5z"></path></svg></button>';
}

/**
 * @property {string} cover.sizes.lqip  LQIP Cover size
 * @property {string} cover.sizes.medium Medium Cover size
 * @param {object} book Book properties
 * @param {boolean} actions Use action dropdown
 * @param {boolean} cover Use cover
 * @param {boolean} lqip User LQIP cover size & lazy load
 * @param escape Escape function
 * @returns {string}
 */
export function getFlexDataBookTemplate(book, actions, cover, lqip, escape) {
  var _book$cover$sizes$lqi, _book$cover, _book$cover$sizes$med, _book$cover2;
  if (actions === void 0) {
    actions = false;
  }
  if (cover === void 0) {
    cover = true;
  }
  if (lqip === void 0) {
    lqip = false;
  }
  var bookTemplate = '';
  var bookActionTemplate = '<div class="flex-data-action">' + '<div class="dropdown">' + getMoreBtn() + '<div class="dropdown-menu dropdown-menu-arrow dropdown-menu-end">' + '<a class="dropdown-item" href="' + adminConfig.routes.bookEdit.replace('[bookId]', book.id) + '">' + i18n.gettext('Update') + '</a>' + '<a class="dropdown-item" href="' + adminConfig.routes.bookClone.replace('[bookId]', book.id) + '">' + i18n.gettext('Clone') + '</a>' + '<button type="button" class="dropdown-item remove-list-item" data-route="' + adminConfig.routes.apiBookDelete.replace('[bookId]', book.id) + '" data-container="books-container">' + i18n.gettext('Delete') + '</button>' + '</div>' + '</div>' + '</div>';
  var lqipCover = (_book$cover$sizes$lqi = (_book$cover = book.cover) == null || (_book$cover = _book$cover.sizes) == null ? void 0 : _book$cover.lqip) != null ? _book$cover$sizes$lqi : adminConfig.images.noCoverPath;
  var mediumCover = (_book$cover$sizes$med = (_book$cover2 = book.cover) == null || (_book$cover2 = _book$cover2.sizes) == null ? void 0 : _book$cover2.medium) != null ? _book$cover$sizes$med : adminConfig.images.noCoverPath;
  var coverSrc = lqip ? 'src="' + lqipCover + '" data-src="' + mediumCover + '"' : 'src="' + mediumCover + '"';
  var bookCoverTemplate = '<div class="flex-data-image">' + '<div class="lazy-container rounded">' + '<img class="rounded pe-none img-blur lazy" ' + coverSrc + ' alt="' + book.title + '" width="50" height="75">' + '</div>' + '</div>';
  bookTemplate += '<div class="flex-data-item">' + (cover ? bookCoverTemplate : '') + '<div class="flex-data-body">' + '<div class="row">' + '<div class="col-6 col-lg-6 mb-1">' + '<div class="flex-data-title">' + i18n.gettext('Title') + '</div>' + '<div class="flex-data-content">' + '<a class="text-reset fw-semibold" href="' + adminConfig.routes.bookEdit.replace('[bookId]', book.id) + '">' + escape(book.title) + (book.publishingYear ? ' (' + escape(book.publishingYear) + ')' : '') + '</a>' + '</div>' + '</div>' + '<div class="col-6 col-lg-3 mb-1">' + '<div class="flex-data-title">' + i18n.gettext('ISBN') + '</div>' + '<div class="flex-data-content">' + (book.ISBN ? escape(book.ISBN) : '-') + '</div>' + '</div>' + '<div class="col-6 col-lg-3 mb-1">' + '<div class="flex-data-title">' + i18n.gettext('Publisher') + '</div>' + '<div class="flex-data-content">' + (book.publisher ? escape(book.publisher.name) : '-') + '</div>' + '</div><div class="col-6 col-lg-6 mb-1">' + '<div class="flex-data-title">' + i18n.gettext('Author') + '</div>' + '<div class="flex-data-content">' + (book.authors ? getBookAuthors(book.authors) : '-') + '</div>' + '</div>' + '<div class="col-6 col-lg-6 mb-1">' + '<div class="flex-data-title">' + i18n.gettext('Genre') + '</div>' + '<div class="flex-data-content">' + (book.genres ? getBookGenres(book.genres) : '-') + '</div>' + '</div>' + '</div>' + '</div>' + (actions ? bookActionTemplate : '') + '</div>';
  return bookTemplate;
}